module.exports = "<a href=\"javascript:;\" class=\"history-item-link\" data-type=\"document\" data-id=\"{{Model.Value.DocKey}}\" data-url-title=\"{{Model.Value.UrlTitle}}\" data-render-type=\"{{Model.Value.RenderType}}\">\r\n    <i aria-hidden=\"true\" class=\"fa fa-file\"></i>\r\n    {{Model.Value.Title}}\r\n</a>\r\n<div class=\"timestamp\" title=\"{{Model.Timestamp}}\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/user-history/views/user-history-item-document.html
// module id = 449
// module chunks = 1